

function toggle(button){

    // this works because the button is immediately after the "moreDetails" element it pertains to
    //let Text = button.previousElementSibling;

    // this would work if you move the button so it is not immediately after moreDetails, but still in the same parent div.
    let Text = button.parentElement.querySelector(".moreDetails");
    let Dot = button.parentElement.querySelector(".dots");
   
    
    if(Text.style.display == "none"){
        Text.style.display= "inline";
     
        Dot.style.display= "none";
    }
    else {
        Text.style.display = "none";
      
        Dot.style.display= "inline";
      
    }
   if (button.innerText === "Lire la suite") {
    button.innerText = "Lire moins";
  } else {
    button.innerText = "Lire la suite";
  }
}

const moreDetailses = document.querySelectorAll(".moreDetails");
for (let i = 0; i < moreDetailses.length; i++) {
  moreDetailses[i].style.display = "none";
}


